module.exports = {
	"container": "findify-components-common--sticky__container",
	"wrapper": "findify-components-common--sticky__wrapper",
	"static": "findify-components-common--sticky__static",
	"stuck": "findify-components-common--sticky__stuck",
	"sticky": "findify-components-common--sticky__sticky"
};